import { render, staticRenderFns } from "./WebsitePolicy.vue?vue&type=template&id=6e2846c8&scoped=true&"
import script from "./WebsitePolicy.vue?vue&type=script&lang=js&"
export * from "./WebsitePolicy.vue?vue&type=script&lang=js&"
import style0 from "./WebsitePolicy.vue?vue&type=style&index=0&id=6e2846c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2846c8",
  null
  
)

export default component.exports